export const numberFromFixedPointString = (value: string | undefined): number => {
    if (typeof value !== 'string' || value.trim() === '') return 0;
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
};
